import { render, staticRenderFns } from "./SupportTicketCommentForm.vue?vue&type=template&id=1cfcc29a&"
import script from "./SupportTicketCommentForm.vue?vue&type=script&lang=js&"
export * from "./SupportTicketCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketCommentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports